import { ICardTokProps } from './CardTok/CardTok';

export const cardsTok: Array<ICardTokProps> = [
  {
    title: '19% on marketing',
    description: 'Thanks to our ecosystem you will be able to earn passively and actively',
    widthLine: 19,
    colorLine: '#4E00FF',
  },
  {
    title: '10% for advisors',
    description: 'Thanks to our ecosystem you will be able to earn passively and actively',
    widthLine: 10,
    colorLine: '#133D81',
  },
  {
    title: '5% for founders, 6% stacked',
    description: 'Thanks to our ecosystem you will be able to earn passively and actively',
    widthLine: 5,
    colorLine: '#FF850B',
    widthLine2: 6,
    colorLine2: '#663090',
  },
  {
    title: 'P2e 15%',
    description: 'Thanks to our ecosystem you will be able to earn passively and actively',
    widthLine: 15,
    colorLine: '#FF0000',
  },
  {
    title: '30% for liquidity',
    description: 'Thanks to our ecosystem you will be able to earn passively and actively',
    widthLine: 30,
    colorLine: '#1DBEE1',
  },
  {
    title: 'NFT 15%',
    description: 'Thanks to our ecosystem you will be able to earn passively and actively',
    widthLine: 15,
    colorLine: '#0096F2',
  },
];
